module.exports = __webpack_public_path__ + "img/icon_map_2.04e2b147.png";